import script from "./menuDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./menuDetail.vue?vue&type=script&setup=true&lang=js"

import "./menuDetail.vue?vue&type=style&index=0&id=6c2d5eea&scoped=true&lang=css"

import exportComponent from "/var/www/html/koboeat/test/customer_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c2d5eea"]])

export default __exports__